import { FC } from 'react';
import { useEligibility } from '@frontend/user-preferences';
import { PatientInsightTeaserVariantB } from './patient-insight-teaser-variant-b';

export interface PatientInsightTeaserProps {
  locationId?: string;
  onViewDemo?: () => void;
}

export const PatientInsightTeaser: FC<PatientInsightTeaserProps> = ({ locationId, onViewDemo }) => {
  const { recordDismiss, shouldShow } = useEligibility({
    featureId: 'patient-insight-teaser',
    defaultCriteria: {
      type: 'dismiss-cooldown',
      maxDismisses: 3,
      cooldownDays: 28,
    },
  });

  if (!shouldShow) {
    return null;
  }

  return <PatientInsightTeaserVariantB onViewDemo={onViewDemo} onDismiss={recordDismiss} locationId={locationId} />;
};
